import { BinaryReader } from "../../../binary";
import { createProtobufRpcClient } from "@cosmjs/stargate";
import { QueryAllIndicesRequest, QueryAllIndicesResponse, QueryStoreKeysRequest, QueryStoreKeysResponse, QueryVersionsRequest, QueryVersionsResponse, QueryEntryRequest, QueryEntryResponse } from "./query";
export class QueryClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.allIndices = this.allIndices.bind(this);
        this.storeKeys = this.storeKeys.bind(this);
        this.versions = this.versions.bind(this);
        this.entry = this.entry.bind(this);
    }
    allIndices(request) {
        const data = QueryAllIndicesRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.fixationstore.Query", "AllIndices", data);
        return promise.then(data => QueryAllIndicesResponse.decode(new BinaryReader(data)));
    }
    storeKeys(request = {}) {
        const data = QueryStoreKeysRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.fixationstore.Query", "StoreKeys", data);
        return promise.then(data => QueryStoreKeysResponse.decode(new BinaryReader(data)));
    }
    versions(request) {
        const data = QueryVersionsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.fixationstore.Query", "Versions", data);
        return promise.then(data => QueryVersionsResponse.decode(new BinaryReader(data)));
    }
    entry(request) {
        const data = QueryEntryRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.fixationstore.Query", "Entry", data);
        return promise.then(data => QueryEntryResponse.decode(new BinaryReader(data)));
    }
}
export const createRpcQueryExtension = (base) => {
    const rpc = createProtobufRpcClient(base);
    const queryService = new QueryClientImpl(rpc);
    return {
        allIndices(request) {
            return queryService.allIndices(request);
        },
        storeKeys(request) {
            return queryService.storeKeys(request);
        },
        versions(request) {
            return queryService.versions(request);
        },
        entry(request) {
            return queryService.entry(request);
        }
    };
};
